import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaCache from './media-cache-model'
import {
  delete_mediaCache,
  load_mediaCaches,
  store_mediaCache,
} from './mediaCache-service'

export const LoadMediaCachesAsync = createAsyncThunk<any, any>(
  'composer/load/mediaCache',
  async (params: { uid: string }) => {
    return await load_mediaCaches(params)
  },
)

export const CreateMediaCacheAsync = createAsyncThunk<any, any>(
  'composer/create/mediaCache',
  async (params: MediaCache) => {
    return await store_mediaCache(params)
  },
)

export const DeleteMediaCacheAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaCache',
  async (params) => {
    return await delete_mediaCache(params)
  },
)
